import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listUser } from '../../redux/slices/user.slice';
import { listTache, createTache, updateTache, deleteTache } from '../../redux/slices/tache.slice';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { use } from 'react';
import PageContainer from '../../components/container/PageContainer';
import Breadcrumb from '../../layouts/full-layout/breadcrumb/Breadcrumb';

const typeTaches = [
  { value: 'cmd-a-valider', label: 'Commande A Valider', color: '#FFB84D' }, // Light orange for validation
  { value: 'cmd-a-valider-cq', label: 'Commande A Valider Cq', color: '#FF8C00' }, // Darker orange for "CQ" validation
  { value: 'cmd-a-saisir', label: 'Commande A Saisir', color: '#4CAF50' }, // Green for "Saisir" (input action)
  { value: 'cmd-a-ettiqueter', label: 'Commande A Ettiqueter', color: '#00BCD4' }, // Cyan for "Ettiqueter" (labeling)
  { value: 'cmd-a-envoyer', label: 'Commande A Envoyer', color: '#2196F3' }, // Blue for "Envoyer" (sending)
  { value: 'cmd-a-receptionner', label: 'Commande A Receptionner', color: '#673AB7' }, // Purple for "Receptionner" (receiving)
  { value: 'cmd-a-livrer', label: 'Commande A Livrer', color: '#F44336' }, // Red for "Livrer" (delivery)
  { value: 'cmd-a-resoudre', label: 'Commande A Resoudre', color: '#9C27B0' }, // Purple for "Resoudre" (resolution)
  { value: 'autre', label: 'Autre', color: '#B0BEC5' }, // Grey for "Autre" (other/general)
];

const tacheStatus = {
  EN_ATTENTE: 'en-attente',
  EN_COURS: 'en-cours',
  TRAITE: 'traite',
  ANNULE: 'annule',
};

const BCrumb = [
  {
    to: '/app',
    title: 'Home',
  },
  {
    title: 'Tâches',
  },
];

const TacheListContainer = () => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.tache_store);
  const [lst_user, set_lst_user] = useState([]);
  const [lst_tache, set_lst_tache] = useState([]);
  const [sel_tache, set_sel_tache] = useState(null);
  const [show_form, set_show_form] = useState(false);
  
  const { sel_sw_mg } = useSelector((state) => state.ui_store);
  useEffect(() => {
    load_data();
  },[sel_sw_mg])

  const load_users = () => {
    dispatch(listUser())
      .unwrap()
      .then((res) => {
        set_lst_user(Array.isArray(res) ? res : []);
      });
  };

  const load_data = () => {
    dispatch(listTache())
      .unwrap()
      .then((res) => {
        set_lst_tache(Array.isArray(res) ? res : []);
      });
  };

  const onCreateTache = (data) => {
    try {
      if (data)
        dispatch(createTache(data))
          .unwrap()
          .then((res) => {
            set_show_form(false);
            load_data();
          });
    } catch (error) {
      console.log(error);
    }
  };
  const onUpdateTache = (data) => {
    try {
      if (data)
        dispatch(updateTache(data))
          .unwrap()
          .then((res) => {
            set_show_form(false);
            load_data();
          });
    } catch (error) {
      console.log(error);
    }
  };
  const onDeleteTache = (id) => {
    try {
      if (id)
        dispatch(deleteTache(id))
          .unwrap()
          .then((res) => {
            load_data();
          });
    } catch (error) {
      console.log(error);
    }
  };

  const onShowForm = (data) => {
    set_sel_tache(data);
    set_show_form(true);
  };
  const onCloseForm = (data) => {
    set_sel_tache(null);
    set_show_form(false);
  };

  useEffect(() => {
    load_users();
    load_data();
  }, []);

  return (
    <PageContainer title="Les Tâches" description="">
      {/* breadcrumb */}
      <Breadcrumb title="Les Tâches" items={BCrumb} />
      {/* end breadcrumb */}

      {/* Magasin List */}
      <TacheList
        lst_tache={lst_tache}
        lst_user={lst_user}
        onShowForm={onShowForm}
        loading={loading}
        error={error}
        onUpdateTache={onUpdateTache}
        onDeleteTache={onDeleteTache}
      />

      {/* Magasin Form */}
      <TacheForm
        show={show_form}
        onClose={onCloseForm}
        lst_user={lst_user}
        onCreateTache={onCreateTache}
        onUpdateTache={onUpdateTache}
        sel_tache={sel_tache}
        loading={loading}
        error={error}
      />
    </PageContainer>
  );
};

const TacheForm = ({
  show,
  onClose,
  sel_tache,
  onCreateTache,
  onUpdateTache,
  lst_user,
  loading,
  error,
}) => {
  const [form_values, set_form_values] = useState({
    user: null,
    description: '',
    type: 'autre',
    is_urgent: false,
    date_urgent: '',
  });

  const [field_keys, set_field_keys] = useState({
    user: `select-user-${Date.now()}`,
    type: `select-type-${Date.now()}`,
  });

  useEffect(() => {
    if (sel_tache) {
      set_form_values({
        user: sel_tache?.user,
        description: sel_tache?.description,
        type: sel_tache?.type,
        is_urgent: sel_tache?.is_urgent,
        date_urgent: sel_tache?.date_urgent,
      });
    } else
      set_form_values({
        user: null,
        description: '',
        type: 'autre',
        is_urgent: false,
        date_urgent: '',
      });

    set_field_keys({
      user: `select-user-${Date.now()}`,
      type: `select-type-${Date.now()}`,
    });
  }, [sel_tache]);

  const onSubmit = () => {
    if (sel_tache) {
      let tmp = { ...form_values, idTache: sel_tache?.idTache };
      onUpdateTache(tmp);
    } else onCreateTache({...form_values, magasin: form_values?.user?.magasin});
  };
  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      open={show}
    >
      <DialogTitle>
        <Typography variant="h5" color={'primary.main'}>
          Nouvelle Tâche
        </Typography>
      </DialogTitle>

      <DialogContent dividers>
        {error && (
          <Alert variant="filled" severity="error" sx={{ my: 1 }}>
            {error}
          </Alert>
        )}
        <Grid container spacing={1}>
          <Grid item lg={12} xs={12}>
            <Typography>Utilisateur</Typography>
            {sel_tache ? (
              <TextField
                disabled
                size="small"
                fullWidth
                type="text"
                value={`${sel_tache?.user?.nom} ${sel_tache?.user?.prenom}`}
              />
            ) : (
              <Autocomplete
                disabled={loading}
                fullWidth
                id="filter-users"
                key={field_keys.user}
                options={!lst_user ? [] : lst_user}
                getOptionLabel={(el) => `${el?.nom} ${el?.prenom} (${el?.email})`}
                onChange={(event, newValue) => {
                  console.log(newValue);
                  set_form_values({ ...form_values, user: newValue });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Nom/Prénom/Email ..."
                    error={!form_values?.user}
                  />
                )}
              />
            )}
          </Grid>
          <Grid item lg={12} xs={12}>
            <Typography variant="subtitle2" fontWeight={500}>
              Type de tâche
            </Typography>

            <Autocomplete
              fullWidth
              id="filter-type-tache"
              key={field_keys.type}
              loading={loading}
              options={!typeTaches ? [] : typeTaches}
              getOptionLabel={(el) => `${el?.label}`}
              onChange={(event, newValue) => {
                set_form_values({ ...form_values, type: newValue?.value });
              }}
              renderInput={(params) => (
                <TextField {...params} size="small" placeholder={''} error={!form_values?.type} />
              )}
            />
          </Grid>
          <Grid item lg={12} xs={12}>
            <Typography>Description</Typography>
            <TextField
              disabled={loading}
              size="small"
              fullWidth
              type="text"
              value={form_values?.description}
              onChange={(e) => set_form_values({ ...form_values, description: e?.target?.value })}
            />
          </Grid>

          <Grid item lg={4} xs={4}>
            <Typography variant="subtitle2">Urgent</Typography>
            <Switch
              size="small"
              checked={form_values.is_urgent}
              onChange={(e) => set_form_values({ ...form_values, is_urgent: e?.target?.checked })}
            />
          </Grid>

          {form_values?.is_urgent && (
            <Grid item lg={8} xs={8}>
              <Typography>Date Urgent</Typography>
              <TextField
                disabled={loading}
                size="small"
                fullWidth
                type="date"
                value={form_values?.date_urgent}
                onChange={(e) => set_form_values({ ...form_values, date_urgent: e?.target?.value })}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          autoFocus
          variant="contained"
          color="secondary"
          onClick={onClose}
          disabled={loading}
        >
          Fermer
        </Button>
        <Button variant="contained" color="success" onClick={onSubmit} disabled={loading}>
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const TacheList = ({
  lst_tache,
  loading,
  error,
  lst_user,
  onShowForm,
  onUpdateTache,
  onDeleteTache,
}) => {
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({
    user: null,
    status: '',
    type: '',
    isUrgent: false,
  });

  // Handle filter change
  const handleFilterChange = (e, filterType) => {
    let newFilters = { ...filters };
    if(e?.target?.value)
    newFilters = { ...filters, [filterType]: e.target.value };
    setFilters(newFilters);
    console.log(newFilters)

    // Apply filters based on selected values
    const filtered = lst_tache.filter((item) => {
      return (
        (newFilters.user ? item.user?.id === newFilters.user?.id : true) &&
        (newFilters.status ? item.status === newFilters.status : true) &&
        (newFilters.type ? item.type === newFilters.type : true) &&
        (newFilters.isUrgent !== false ? item.is_urgent === newFilters.isUrgent : true)
      );
    });

    setFilteredData(filtered);
  };

  // Filter urgent checkbox
  const handleUrgentFilterChange = (e) => {
    const newFilters = { ...filters, isUrgent: e.target.checked };
    setFilters(newFilters);

    const filtered = lst_tache.filter((item) => {
      return (
        (newFilters.user ? item.user.id === newFilters.user.id : true) &&
        (newFilters.status ? item.status === newFilters.status : true) &&
        (newFilters.type ? item.type === newFilters.type : true) &&
        (newFilters.isUrgent !== false ? item.is_urgent === newFilters.isUrgent : true)
      );
    });

    setFilteredData(filtered);
  };

  useEffect(() => {
    setFilteredData(lst_tache);
  },[lst_tache])

  return (
    <div>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            value={filters.user}
            onChange={(e, newValue) => handleFilterChange({ target: { value: newValue } }, 'user')}
            options={lst_user}
            getOptionLabel={(option) => `${option?.nom} ${option?.prenom}`}
            renderInput={(params) => <TextField {...params} label="User" />}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              value={filters.status}
              onChange={(e) => handleFilterChange(e, 'status')}
              label="Status"
            >
              {Object.values(tacheStatus).map((status) => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth>
            <InputLabel>Type</InputLabel>
            <Select
              value={filters.type}
              onChange={(e) => handleFilterChange(e, 'type')}
              label="Type"
            >
              {Object.values(typeTaches).map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormControlLabel
            control={<Checkbox checked={filters.isUrgent} onChange={handleUrgentFilterChange} />}
            label="Urgent"
          />
        </Grid>
      </Grid>

      <Box textAlign={'end'}>
        <Button onClick={() => onShowForm(null)} variant="outlined" color="success">
          Nouvelle Tâche
        </Button>
      </Box>

      <TableContainer>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Urgent</TableCell>
              <TableCell>Date urgent</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.map((tache) => (
              <TableRow key={tache.idTache}>
                <TableCell>
                  {' '}
                  <Chip
                    size="small"
                    label={typeTaches?.find((type) => type.value === tache.type)?.label}
                    sx={{
                      backgroundColor: typeTaches?.find((type) => type.value === tache.type)?.color,
                      textTransform: 'capitalize',
                      borderRadius: 1,
                      color: 'white',
                    }}
                  />{' '}
                </TableCell>
                <TableCell sx={{ color: 'primary.main', fontWeight: 500 }}>
                  {tache.user?.nom} {tache.user?.prenom}
                </TableCell>
                <TableCell>
                    <Chip
                    size="small"
                    label={tache.status}
                    color={tache.status === 'traite' ? 'success' : tache.status === 'en-cours' ? 'primary' : 'warning'}
                    sx={{
                      textTransform: 'capitalize',
                      borderRadius: 1,
                      color: 'white',
                    }}
                  />
                </TableCell>
                <TableCell>{tache.description}</TableCell>
                <TableCell>{tache.is_urgent ? 'Oui' : 'Non'}</TableCell>
                <TableCell>{tache.date_urgent ? tache.date_urgent : 'N/A'}</TableCell>
                <TableCell>
                  {tache.status === 'en-attente' && (
                    <Button
                      size="small"
                      onClick={() => onUpdateTache({ idTache: tache?.idTache, status: 'en-cours' })}
                      variant="outlined"
                      color="primary"
                    >
                      Mettre en cours
                    </Button>
                  )}
                  {tache.status === 'en-cours' && (
                    <Button
                      size="small"
                      onClick={() => onUpdateTache({ idTache: tache?.idTache, status: 'traite' })}
                      variant="outlined"
                      color="success"
                      sx={{ ml: 1 }}
                    >
                      Mettre traité
                    </Button>
                  )}
                  <Button
                    size="small"
                    onClick={() => onShowForm(tache)}
                    variant="outlined"
                    color="secondary"
                    sx={{ ml: 1 }}
                  >
                    Modifier
                  </Button>
                  <Button
                    size="small"
                    onClick={() => onDeleteTache(tache?.idTache)}
                    variant="outlined"
                    color="error"
                    sx={{ ml: 1 }}
                  >
                    Annuler
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default TacheListContainer;
